<template>
  <div>

  <TableView
    :key="invalidate"
    :headers="columns"
    :pagination="pagination"
    :rows="items"      
    :sort="sort1"
    @onRowClicked="onRowClicked"
  >
    <template v-slot:items="{ row }">
      <td class="table-img-wrapper">
        <!--<div class="table-img" :style="getImageStyle(row)"></div>-->
        <lazy-background
          :key="row.img"
          class="table-img" 
          :image-source="row.img"
          loading-image="/images/loader/loading.gif"
          error-image="/images/heart_light.png"
          image-class=""
          background-size="cover"
          >
        </lazy-background>
      
      </td> 
      <td>{{ row.company }}</td> 
      <td>{{ row.title }}</td>
      <td>{{ getTablerContact(row) }}</td> 
      <td>{{ row.shipText }}</td>
      <!--<td>{{ row.descr }}</td>  -->            
      <!-- <td>{{ row.category }}</td>  -->               
      <!-- <td v-if="!isSmallTouchDevice()">{{ row.shipText }}</td>  -->    
    </template>

    <template v-slot:no-data>
      <div style="text-align:center;padding:1rem;">Leider ergab die Suche keine Treffer </div>
    </template>
  </TableView>
  </div>
</template>

<script>
import {helper} from '@/mixins/helper.js'
import {shopBase} from '@/mixins/shopBase.js'
import TableView from '@/components/table/TableView.vue'
export default {
  name: 'RTlist',
  props:{
    items:{
      type:Array,
      default:new Array()
    },
  },
  mixins:[helper,shopBase],
  components:{
    TableView,
  },
  watch:{
    items(){
      this.invalidate++;
    }
  },
  data: function() {
    return {
      invalidate:0,
      sort1:{
        field: 'company',
        order: 'asc'
      },
      columns : [],
        pagination:{
        itemsPerPage: 6,
        align: 'center'
      }
    };
  },
  methods:{

    getColumns(){
      let res= [
        {"label":"","field":"img","sortable":false,"type":"String"},
        {"label":"Unternehmen","field":"company","sortable":true,"type":"String"},
        {"label":"Bereich","field":"title","sortable":true,"type":"String"},
        {"label":"Kontakt","field":"contact","sortable":true,"type":"String"},
        {"label":"Versand","field":"ship","sortable":true,"type":"String"}
        // {"label":"Beschreibung","field":"descr","sortable":true,"type":"String"},
        // {"label":"Kategorie","field":"category","sortable":true,"type":"String"},
      ]

      /*
      if(!this.isSmallTouchDevice()){
        res.push({"label":"Versand","field":"ship","sortable":true,"type":"String"});
      }
      */
      return res;
    },
    onRowClicked(row){
      if(row){
        this.$router.push({ name: 'shop', params: { id: this.removeSpecialCharsFromString(row.title) } })
      }
    },
    getImageStyle(shop){
			return {
				'background': 'url('+shop.img+')'
			}
		},
  },
  mounted(){
    this.columns=this.getColumns();
  }
};
</script>

<style>
  .table-img{
      margin: 0.5rem;
      border-radius: 99px;
      height:60px;
      width:60px;
      background-size: cover!important;
  }
  .table-img-wrapper{
vertical-align: middle;
  }
  .table-row{
    cursor:pointer!important;
  }
  .table-row:hover{
    background:#7bd0c12b!important;
  }
  .table-row td{
    vertical-align: middle;
  }
</style>

<style lang="scss">
.separator{
  margin: 2em 0;
  text-align: center;
}
.custom-style {
  // Table styles
  .ozn-table {
    border-collapse: collapse;
    width: 100%;
    thead {
      th { 
        border-bottom: 1px solid #ffffff;
        padding: 0 10px;
        height: 48px;
        text-align: left; 
        font-size: 1em; 
        color: #fff;
        background-color: #7cc3fd; 
        cursor: pointer; 
        &:hover{
          span{
            text-decoration: underline;
            text-decoration-style: dotted;
          }
        }        
        i{
          color: #ffffff; 
          &.active{
            color: #ff00aa;
            + span{
              color: #a9237c;
            }
          }
        }       
      }
    }
    tbody {
      tr{
        &:nth-child(odd){
          background-color: #e9f5ff;
        }
        &:nth-child(even){
          background-color: #fafaeb;
        }
      }
      td {
        border-bottom: 1px solid #ffffff;
        padding: 0 10px;
        height: 48px;
        font-size: 1em; 
      }
    }
  }
  // Paginator styles    
  .ozn-paginator{
    margin-top: .5em;
    select{
      border: 1px solid #7cc3fd;
      border-radius: 8px;
      color: #ffffff;
      background-color:  #7cc3fd;
      outline: none;
    }
    button{
      border: 1px solid #7cc3fd;
      border-radius: 8px;
      color: #ffffff;
      background-color:  #7cc3fd;
      outline: none;
    }    
  }
}
</style>